'use strict';

// Brand wrapper — reads the deterministic brand block emitted by
// `npm run brand` (which calls pict-section-theme-brand in standalone
// mode using the retold.brandConfig hints in package.json). Passed to
// Theme-Section as the `Brand` option so the brand mark + brand color
// vars are wired into every themed surface.

const tmpPackage = require('../package.json');

if (!tmpPackage.retold || !tmpPackage.retold.brand)
{
	throw new Error('plansheet: package.json is missing retold.brand — '
		+ 'run `npm run brand` (which calls pict-section-theme-brand) before building');
}

module.exports = tmpPackage.retold.brand;
